export default __webpack_public_path__ + "static/media/do-be-patient.21deedd1.svg";